export class CreateAddressTypeModel {
  public descricao: string = ''
}

export class EditAddressTypeModel {
  public id: number = 0
  public descricao: string = ''
}

export class DeleteAddressTypeModel {
  public id: number = 0
  public descricao: string = ''
}

export class SearchAddressTypeModel {
  public descricao: string = ''
}

export class CreateAddressTypeResponse {
  public response: any
}
export class EditAddressTypeResponse {
  public response: any
}
export class DeleteAddressTypeResponse {
  public response: any
}
export class PagedAddressTypeResponse {
  public response: any
}
